"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addLeadingZero = void 0;

var addLeadingZero = function addLeadingZero(i) {
  var str = String(i + 1);
  return str.length === 1 ? "0".concat(str) : str;
};

exports.addLeadingZero = addLeadingZero;